import type { GearEffectId } from '../battle/types';
import type { CraftItem, GearSize } from './types';

// Default gear size per skill. The hex craft has no sizes anymore - this
// anchors DEMO enemy charge rates (defaultChargeRates) and the battle HUD
// mini-gear look only.
export const GEAR_SKILLS: { skillId: string; size: GearSize }[] = [
  { skillId: 'repair', size: 4 },
  { skillId: 'charge', size: 4 },
  { skillId: 'sparky_bunker', size: 5 },
  { skillId: 'blink', size: 5 },
  { skillId: 'cannon', size: 6 },
  { skillId: 'earthshake', size: 6 },
];

// Tooth count per gear size - still the anchor of charge-rate math: a hex
// skill node consumes flux like a SMALL gear did (see compile.ts NODE_TEETH),
// and demo enemies charge at their catalog-size rate. Also feeds the battle
// HUD mini-gear geometry.
export const TEETH_BY_SIZE: Record<GearSize, number> = { 4: 9, 5: 11, 6: 13 };

// Gear effects sold as nodes. Ids double as icon file base names in
// /assets/ui/Effects. A powered effect node buffs EVERY skill node linked to
// it (hex adjacency, no spread limit).
export const GEAR_EFFECT_IDS: readonly GearEffectId[] = [
  'vamp',
  'damage',
  'poison',
  'crit',
  'accuracy',
  'piercing',
];

// Prices. Skills are rough power tiers; routers are cheap plumbing.
export const SKILL_PRICE: Record<string, number> = {
  repair: 15,
  charge: 15,
  sparky_bunker: 25,
  blink: 25,
  cannon: 40,
  earthshake: 40,
};
export const EFFECT_PRICE = 20;
export const PIPE_PRICE = 6;
export const SPLITTER_PRICE = 10;
export const ELBOW_PRICE = 8;
export const KEY_PRICE = 15;

export function itemPrice(item: CraftItem): number {
  if (item.type === 'skill') return SKILL_PRICE[item.skillId] ?? 20;
  if (item.type === 'effect') return EFFECT_PRICE;
  if (item.type === 'pipe') return PIPE_PRICE;
  if (item.type === 'splitter') return SPLITTER_PRICE;
  if (item.type === 'elbow') return ELBOW_PRICE;
  return KEY_PRICE;
}
